import React from 'react';
import { translate } from 'react-i18next';

import * as Depreciation from 'depreciations/components/form';
import * as Common from 'common/components';

const DepreciationFormView = ({
  t,
  depreciation,
  company,
  handleAddYear,
  handleRemoveYear,
  handleSubmit,
  handleValueChange,
  handleValidation,
  subcompany,
  isFetching,
  handleGroupChange, //Groups
  handleCustomFieldChange, //Groups
  groups, //Groups
  isSubmitted,
  isSaving,
}) => (
  <Common.Wrapper fluid={true}>
    {/* <Common.Header title={t("depreciations.depreciations_title")} /> */}
    <div className="col-12">
      <Common.Portlet
        title={
          t('menu.configuration') +
          ' > ' +
          t('depreciations.depreciations_title') +
          ' > ' +
          t(depreciation.id ? 'depreciations.edit' : 'depreciations.add')
        }
        icon={'calculator'}
      >
        <Depreciation.Form
          company={company}
          handleAddYear={handleAddYear}
          handleRemoveYear={handleRemoveYear}
          handleSubmit={handleSubmit}
          handleValidation={handleValidation}
          handleValueChange={handleValueChange}
          isSubmitted={isSubmitted}
          handleGroupChange={handleGroupChange} //Groups
          handleCustomFieldChange={handleCustomFieldChange} //Groups
          groups={groups} //Groups
          isSaving={isSaving}
          subcompany={subcompany}
          values={depreciation}
        />
        <Common.LoaderOverlay show={isFetching} />
      </Common.Portlet>
    </div>
  </Common.Wrapper>
);

export default translate()(DepreciationFormView);



// WEBPACK FOOTER //
// src/modules/secured/modules/depreciations/components/DepreciationFormView.js